module.exports = __webpack_public_path__ + "img/67200.81bce533.jpg";